const eceData2 = [
  {
    id: 51,
    category: "ECE",
    level: "hard",
    question:
      "In a BJT, what effect does increasing the collector-base reverse bias have on the base width?",
    options: [
      "Increases base width",
      "Decreases base width (base-width modulation)",
      "No effect on base width",
      "Base width becomes infinite",
    ],
    answer: "Decreases base width (base-width modulation)",
  },
  {
    id: 52,
    category: "ECE",
    level: "hard",
    question:
      "Which parameter primarily determines the cutoff frequency of a common-emitter amplifier?",
    options: [
      "Collector current",
      "Base resistance and coupling capacitance",
      "Emitter voltage",
      "Supply voltage",
    ],
    answer: "Base resistance and coupling capacitance",
  },
  {
    id: 53,
    category: "ECE",
    level: "hard",
    question:
      "What is the main advantage of a common-collector (emitter follower) amplifier?",
    options: [
      "High voltage gain",
      "High input resistance and low output resistance",
      "High current gain only",
      "Low input resistance",
    ],
    answer: "High input resistance and low output resistance",
  },
  {
    id: 54,
    category: "ECE",
    level: "hard",
    question:
      "In a MOSFET, what effect does increasing the gate-to-source voltage beyond the threshold have?",
    options: [
      "Reduces channel conductivity",
      "Increases drain current in saturation",
      "Turns off the device",
      "No effect on drain current",
    ],
    answer: "Increases drain current in saturation",
  },
  {
    id: 55,
    category: "ECE",
    level: "hard",
    question:
      "Which factor mainly limits the high-frequency response of a transistor amplifier?",
    options: [
      "Collector current",
      "Parasitic capacitances and transit time",
      "Emitter resistor",
      "Supply voltage",
    ],
    answer: "Parasitic capacitances and transit time",
  },
  {
    id: 56,
    category: "ECE",
    level: "hard",
    question:
      "In a phase-locked loop (PLL), what component determines the output frequency range?",
    options: [
      "Phase detector",
      "Loop filter",
      "Voltage-controlled oscillator (VCO)",
      "Reference signal",
    ],
    answer: "Voltage-controlled oscillator (VCO)",
  },
  {
    id: 57,
    category: "ECE",
    level: "hard",
    question:
      "Why is a Darlington pair not preferred for high-speed switching?",
    options: [
      "It has low current gain",
      "High input resistance",
      "High V_BE(sat) and slow turn-off",
      "Cannot be used in common-emitter",
    ],
    answer: "High V_BE(sat) and slow turn-off",
  },
  {
    id: 58,
    category: "ECE",
    level: "hard",
    question: "In digital communication, what is the purpose of line coding?",
    options: [
      "To convert analog signals to digital",
      "To reduce bandwidth and enable clock recovery",
      "To amplify the signal",
      "To increase noise",
    ],
    answer: "To reduce bandwidth and enable clock recovery",
  },
  {
    id: 59,
    category: "ECE",
    level: "hard",
    question:
      "What is the primary advantage of a Bessel filter over Butterworth and Chebyshev filters?",
    options: [
      "Sharper roll-off",
      "Maximally flat magnitude response",
      "Linear phase response, preserving signal shape",
      "Simplest design",
    ],
    answer: "Linear phase response, preserving signal shape",
  },
  {
    id: 60,
    category: "ECE",
    level: "hard",
    question:
      "In a common-source MOSFET amplifier, which parameter mainly affects voltage gain?",
    options: [
      "Gate-to-source capacitance",
      "Transconductance (g_m) and load resistance",
      "Source voltage only",
      "Drain voltage only",
    ],
    answer: "Transconductance (g_m) and load resistance",
  },
  {
    id: 61,
    category: "ECE",
    level: "hard",
    question: "What is the main cause of thermal runaway in a BJT?",
    options: [
      "Collector current decreasing with temperature",
      "Increasing temperature increases collector current, which further increases temperature",
      "Base current decreasing with voltage",
      "Emitter resistor overheating",
    ],
    answer:
      "Increasing temperature increases collector current, which further increases temperature",
  },
  {
    id: 62,
    category: "ECE",
    level: "hard",
    question: "Why is impedance matching important in RF transmission lines?",
    options: [
      "To minimize power loss and reflections",
      "To increase voltage gain",
      "To reduce current",
      "To improve thermal stability",
    ],
    answer: "To minimize power loss and reflections",
  },
  {
    id: 63,
    category: "ECE",
    level: "hard",
    question:
      "Which ADC type achieves high resolution using oversampling and noise shaping?",
    options: [
      "Flash ADC",
      "Successive Approximation ADC",
      "Delta-Sigma ADC",
      "Dual-slope ADC",
    ],
    answer: "Delta-Sigma ADC",
  },
  {
    id: 64,
    category: "ECE",
    level: "hard",
    question: "What is the main function of a bandgap reference in ICs?",
    options: [
      "Amplify signals",
      "Provide a stable voltage independent of temperature",
      "Act as a filter",
      "Provide a clock signal",
    ],
    answer: "Provide a stable voltage independent of temperature",
  },
  {
    id: 65,
    category: "ECE",
    level: "hard",
    question: "In an RF power amplifier, why is linearity important?",
    options: [
      "For maximum efficiency",
      "To minimize distortion and intermodulation products",
      "To reduce DC current",
      "To reduce heat",
    ],
    answer: "To minimize distortion and intermodulation products",
  },
  {
    id: 66,
    category: "ECE",
    level: "hard",
    question: "What is the main purpose of a Schmitt trigger?",
    options: [
      "Amplify signals",
      "Provide hysteresis to reduce noise on digital signals",
      "Act as a low-pass filter",
      "Act as a high-pass filter",
    ],
    answer: "Provide hysteresis to reduce noise on digital signals",
  },
  {
    id: 67,
    category: "ECE",
    level: "hard",
    question:
      "Which parameter mainly determines the cutoff frequency of an RC low-pass filter?",
    options: [
      "Resistance only",
      "Capacitance only",
      "RC product",
      "Supply voltage",
    ],
    answer: "RC product",
  },
  {
    id: 68,
    category: "ECE",
    level: "hard",
    question: "In a digital system, what is the purpose of a flip-flop?",
    options: [
      "Amplify a signal",
      "Store a single bit of data",
      "Convert analog to digital",
      "Filter a digital signal",
    ],
    answer: "Store a single bit of data",
  },
  {
    id: 69,
    category: "ECE",
    level: "hard",
    question: "What is the main advantage of using a differential amplifier?",
    options: [
      "High output voltage",
      "Reject common-mode signals and noise",
      "High current gain",
      "Low input impedance",
    ],
    answer: "Reject common-mode signals and noise",
  },
  {
    id: 70,
    category: "ECE",
    level: "hard",
    question:
      "Which of the following causes phase margin reduction in feedback systems?",
    options: [
      "Excessive gain",
      "Time delay in the loop",
      "High supply voltage",
      "Low load resistance",
    ],
    answer: "Time delay in the loop",
  },
  {
    id: 71,
    category: "ECE",
    level: "hard",
    question: "What is crosstalk in high-speed digital circuits?",
    options: [
      "Noise from the power supply",
      "Signal coupling between adjacent traces",
      "Clock skew",
      "Thermal noise",
    ],
    answer: "Signal coupling between adjacent traces",
  },
  {
    id: 72,
    category: "ECE",
    level: "hard",
    question: "Which type of ADC is fastest but consumes the most power?",
    options: [
      "Flash ADC",
      "Successive Approximation ADC",
      "Sigma-Delta ADC",
      "Dual-Slope ADC",
    ],
    answer: "Flash ADC",
  },
  {
    id: 73,
    category: "ECE",
    level: "hard",
    question:
      "Why is a folded-cascode op-amp preferred over a telescopic cascode in student-level designs?",
    options: [
      "Higher gain only",
      "Simpler to bias",
      "Larger input and output voltage range",
      "Lower noise",
    ],
    answer: "Larger input and output voltage range",
  },
  {
    id: 74,
    category: "ECE",
    level: "hard",
    question: "What does the term 'setup time' refer to in flip-flops?",
    options: [
      "Minimum time before clock edge that data must be stable",
      "Time to switch output",
      "Hold time after clock edge",
      "Time for propagation delay",
    ],
    answer: "Minimum time before clock edge that data must be stable",
  },
  {
    id: 75,
    category: "ECE",
    level: "hard",
    question:
      "In a transmission line, what happens when the line is mismatched?",
    options: [
      "Maximum power transfer",
      "Reflections occur",
      "Voltage doubles",
      "Frequency drops",
    ],
    answer: "Reflections occur",
  },
  {
    id: 76,
    category: "ECE",
    level: "hard",
    question:
      "What is the main advantage of using pulse-width modulation (PWM) in Class D amplifiers?",
    options: [
      "High linearity",
      "High efficiency",
      "High distortion",
      "High noise",
    ],
    answer: "High efficiency",
  },
  {
    id: 77,
    category: "ECE",
    level: "hard",
    question: "In digital communication, what is the function of a scrambler?",
    options: [
      "Encrypt data",
      "Randomize data to maintain sufficient transitions",
      "Reduce amplitude",
      "Increase noise",
    ],
    answer: "Randomize data to maintain sufficient transitions",
  },
  {
    id: 78,
    category: "ECE",
    level: "hard",
    question:
      "Which type of filter is best for preserving pulse shape in analog circuits?",
    options: ["Butterworth", "Bessel", "Chebyshev", "Elliptic"],
    answer: "Bessel",
  },
  {
    id: 79,
    category: "ECE",
    level: "hard",
    question:
      "In CMOS circuits, what is the main cause of static power consumption in deep-submicron technologies?",
    options: [
      "Switching power",
      "Subthreshold leakage",
      "Gate capacitance",
      "Supply voltage",
    ],
    answer: "Subthreshold leakage",
  },
  {
    id: 80,
    category: "ECE",
    level: "hard",
    question: "What is the main function of a balun in RF circuits?",
    options: [
      "Amplify signals",
      "Convert balanced to unbalanced line",
      "Filter noise",
      "Mix two frequencies",
    ],
    answer: "Convert balanced to unbalanced line",
  },
  {
    id: 81,
    category: "ECE",
    level: "hard",
    question:
      "What is the main benefit of using a guard ring in CMOS IC layout?",
    options: [
      "Power connection",
      "Heat dissipation",
      "Prevent substrate noise and latch-up",
      "Mark chip boundary",
    ],
    answer: "Prevent substrate noise and latch-up",
  },
  {
    id: 82,
    category: "ECE",
    level: "hard",
    question:
      "Which parameter of an RF amplifier is used to measure linearity?",
    options: ["P1dB point", "Noise figure", "Gain", "Efficiency"],
    answer: "P1dB point",
  },
  {
    id: 83,
    category: "ECE",
    level: "hard",
    question: "What is the main purpose of time-domain reflectometry (TDR)?",
    options: [
      "Measure frequency",
      "Locate faults in cables",
      "Measure power",
      "Measure speed",
    ],
    answer: "Locate faults in cables",
  },
  {
    id: 84,
    category: "ECE",
    level: "hard",
    question:
      "Which effect in a MOSFET reduces output resistance in saturation?",
    options: [
      "Channel length modulation",
      "Gate leakage",
      "Threshold voltage shift",
      "Body effect",
    ],
    answer: "Channel length modulation",
  },
  {
    id: 85,
    category: "ECE",
    level: "hard",
    question: "What is the purpose of a clamp circuit?",
    options: [
      "Limit amplitude",
      "Shift waveform to a DC level",
      "Rectify AC",
      "Filter signals",
    ],
    answer: "Shift waveform to a DC level",
  },
  {
    id: 86,
    category: "ECE",
    level: "hard",
    question:
      "What is the main function of a comparator compared to an op-amp?",
    options: [
      "Linear amplification",
      "Operate in saturation for fast switching",
      "High input impedance only",
      "Store data",
    ],
    answer: "Operate in saturation for fast switching",
  },
  {
    id: 87,
    category: "ECE",
    level: "hard",
    question:
      "In a switched-mode power supply (SMPS), why is efficiency high compared to linear regulators?",
    options: [
      "High frequency",
      "Low voltage drop",
      "Switch operates in cutoff/saturation, minimizing P=V*I",
      "Small transformer",
    ],
    answer: "Switch operates in cutoff/saturation, minimizing P=V*I",
  },
  {
    id: 88,
    category: "ECE",
    level: "hard",
    question:
      "What is the primary cause of electromagnetic interference (EMI) in circuits?",
    options: [
      "High DC current",
      "Rapid voltage and current changes (high dV/dt and dI/dt)",
      "Large components",
      "Thermal noise",
    ],
    answer: "Rapid voltage and current changes (high dV/dt and dI/dt)",
  },
  {
    id: 89,
    category: "ECE",
    level: "hard",
    question:
      "Which technique is used in RF amplifiers to cancel non-linearity?",
    options: ["Feedback", "Digital predistortion (DPD)", "Oversampling", "PWM"],
    answer: "Digital predistortion (DPD)",
  },
  {
    id: 90,
    category: "ECE",
    level: "hard",
    question:
      "What is the purpose of a low-noise amplifier (LNA) in a receiver?",
    options: [
      "Amplify without adding significant noise",
      "Filter high-frequency signals",
      "Provide DC power",
      "Mix signals",
    ],
    answer: "Amplify without adding significant noise",
  },
  {
    id: 91,
    category: "ECE",
    level: "hard",
    question: "In an antenna, directivity measures:",
    options: [
      "Total radiated power",
      "Ratio of radiation intensity in a direction to average intensity",
      "Physical size",
      "Radiation efficiency",
    ],
    answer: "Ratio of radiation intensity in a direction to average intensity",
  },
  {
    id: 92,
    category: "ECE",
    level: "hard",
    question: "What is the purpose of a voltage regulator in a power supply?",
    options: [
      "Amplify voltage",
      "Maintain constant output voltage despite variations in load or input",
      "Filter AC",
      "Rectify DC",
    ],
    answer:
      "Maintain constant output voltage despite variations in load or input",
  },
  {
    id: 93,
    category: "ECE",
    level: "hard",
    question: "What is the function of a P-N junction in semiconductors?",
    options: [
      "Store charge",
      "Allow current in one direction (rectification)",
      "Filter signals",
      "Act as a switch only",
    ],
    answer: "Allow current in one direction (rectification)",
  },
  {
    id: 94,
    category: "ECE",
    level: "hard",
    question: "Which technique reduces switching noise in digital ICs?",
    options: ["Decoupling capacitors", "Inductors", "Resistors", "Diodes"],
    answer: "Decoupling capacitors",
  },
  {
    id: 95,
    category: "ECE",
    level: "hard",
    question:
      "What is the main advantage of using differential signaling over single-ended signaling?",
    options: [
      "Higher speed",
      "Better noise immunity",
      "Lower power",
      "Smaller traces",
    ],
    answer: "Better noise immunity",
  },
  {
    id: 96,
    category: "ECE",
    level: "hard",
    question:
      "In a resonant LC circuit, what happens if the capacitance increases?",
    options: [
      "Resonant frequency increases",
      "Resonant frequency decreases",
      "Voltage increases",
      "Current decreases",
    ],
    answer: "Resonant frequency decreases",
  },
  {
    id: 97,
    category: "ECE",
    level: "hard",
    question: "Which device converts an analog signal into a digital code?",
    options: ["DAC", "ADC", "Amplifier", "Filter"],
    answer: "ADC",
  },
  {
    id: 98,
    category: "ECE",
    level: "hard",
    question: "What is the main function of a varactor diode?",
    options: [
      "Amplification",
      "Frequency tuning using variable capacitance",
      "Rectification",
      "Filtering",
    ],
    answer: "Frequency tuning using variable capacitance",
  },
  {
    id: 99,
    category: "ECE",
    level: "hard",
    question: "What is the main limitation of a common-drain MOSFET amplifier?",
    options: [
      "Low input impedance",
      "No voltage gain (≈1)",
      "High output impedance",
      "Low current gain",
    ],
    answer: "No voltage gain (≈1)",
  },
  {
    id: 100,
    category: "ECE",
    level: "hard",
    question: "Why is negative feedback used in amplifiers?",
    options: [
      "Increase gain",
      "Reduce distortion and improve stability",
      "Increase noise",
      "Increase input impedance only",
    ],
    answer: "Reduce distortion and improve stability",
  },
];
export default eceData2;
